export default __webpack_public_path__ + "static/media/sch7.62a60f6e.jpg";